"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_router_dom_1 = require("react-router-dom");
const AuthProvider_1 = require("./components/AuthProvider");
const ProtectedRoute_1 = __importDefault(require("./components/ProtectedRoute"));
const Dashboard_1 = __importDefault(require("./pages/Dashboard"));
const UserManagement_1 = __importDefault(require("./pages/UserManagement"));
const Login_1 = __importDefault(require("./pages/Login"));
const Navbar_1 = __importDefault(require("./components/Navbar"));
const Logout_1 = __importDefault(require("./pages/Logout"));
const EditLicence_1 = __importDefault(require("./components/EditLicence"));
const CreateLicence_1 = __importDefault(require("./components/CreateLicence"));
const App = () => {
    return (react_1.default.createElement(AuthProvider_1.AuthProvider, null,
        react_1.default.createElement(Navbar_1.default, null),
        react_1.default.createElement(react_router_dom_1.Routes, null,
            react_1.default.createElement(react_router_dom_1.Route, { path: "/", element: react_1.default.createElement(Dashboard_1.default, null) }),
            react_1.default.createElement(react_router_dom_1.Route, { path: "/users", element: react_1.default.createElement(ProtectedRoute_1.default, null,
                    react_1.default.createElement(UserManagement_1.default, null)) }),
            react_1.default.createElement(react_router_dom_1.Route, { path: "/users/:userId/edit", element: react_1.default.createElement(ProtectedRoute_1.default, null,
                    react_1.default.createElement(EditLicence_1.default, null)) }),
            react_1.default.createElement(react_router_dom_1.Route, { path: "/users/:userId/create", element: react_1.default.createElement(ProtectedRoute_1.default, null,
                    react_1.default.createElement(CreateLicence_1.default, null)) }),
            react_1.default.createElement(react_router_dom_1.Route, { path: "/login", element: react_1.default.createElement(Login_1.default, null) }),
            react_1.default.createElement(react_router_dom_1.Route, { path: "/logout", element: react_1.default.createElement(Logout_1.default, null) }))));
};
exports.default = App;
